const getBeamerConfig = () => {
  if (!window.beamer_config) {
    console.warn('No Beamer config Snippet Loaded');
    return {};
  }
  return { beamer_config: window.beamer_config };
};

const getBeamer = () => {
  if (!window.Beamer) {
    console.warn('No Beamer Snippet Loaded');
    return {};
  }
  return window.Beamer;
};

const identify = ({ user = {}, language = 'ES' }) => {
  const { beamer_config } = getBeamerConfig();
  const Beamer = getBeamer();
  if (beamer_config && Beamer) {
    Beamer.update({
      language,
      user_firstname: user.first_name,
      user_lastname: user.last_name,
      user_email: user.email,
      user_id: user.uuid,
    });
    Beamer.init();
  }
};

const hideBeamer = () => {
  const Beamer = getBeamer();
  if (Beamer) {
    Beamer.hide();
  } else {
    console.warn(`Can't hide Beamer, there is no instance.`);
  }
};

const showBeamer = () => {
  const Beamer = getBeamer();
  if (Beamer) {
    Beamer.show();
  } else {
    console.warn(`Can't show Beamer, there is no instance.`);
  }
};

const destroyBeamer = () => {
  const Beamer = getBeamer();
  if (Beamer) {
    Beamer.destroy();
  } else {
    console.warn(`Can't destroy Beamer, there is no instance.`);
  }
};

export { identify, hideBeamer, showBeamer, destroyBeamer };
